import React, { useCallback } from "react";
import "./BasemapItem.css";

interface BasemapItemProps {
    id: string;
    title: string;
    thumbnailUrl: string;
    selectBasemap: () => void;
    isActive: boolean;
}

const BasemapItem: React.FC<BasemapItemProps> = (({ id, title, thumbnailUrl, selectBasemap, isActive }) => {
    const handleBasemapSelect = useCallback(() => {
        selectBasemap();
    }, [title, selectBasemap]);

    return (
        <div className="basemap-item">
            <input checked={isActive} onChange={handleBasemapSelect} type="radio" name="basemap" id={id} />
            <label className="basemap-item-label" htmlFor={id}>
                <span className="basemap-item-label-text">{title}</span>
                <div className="basemap-item-label-img">
                    <img src={thumbnailUrl} alt={`Utklippsbilde av basiskartet ${title}`} />
                </div>
            </label>
        </div>
    );
});

BasemapItem.displayName = "BasemapItem";

export default BasemapItem;
